import ReactDOM from 'react-dom/client';
import './index.css';
import React, { useEffect,useState } from 'react';
import { BrowserRouter} from 'react-router-dom';
import App from './App.js'
const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>

);

